import { useLanguage } from "@/i18n";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee" className="relative overflow-hidden bg-[#0D253A] py-5 select-none">
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-xl sm:text-2xl text-[#F8F5F0]/90 px-8 whitespace-nowrap">{item}</span>
            <span className="w-2 h-2 rounded-full bg-[#C86D51] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
